<script>
import { notify } from '@/helpers/notify' 

export default {
  name: 'TtoysModal',
  props:[
    "xdslno",
    "section"
  ],
  data() {
    return {
      list: {},
      submitted: false,
    };
  },
  watch:{
    section(section){
        const url = (section == 'hat' ? 'hatControl' : 'ttoys')
        this.getData(url)
    }
  },
  methods: {
    getData(url){
        this.$http.post(`/vae/${url}`, { xdslNo: this.xdslno } )
        .then(resp => {
          this.list = resp.data
        })
        .catch(error => error)
    },
    close(){
        this.$bvModal.hide('ttoys_modal')
        return notify.success('resp.data.message')
    }
  },
};
</script>
<template>
<b-modal id="ttoys_modal" title="Ttoys Verileri"  no-close-on-backdrop hide-footer>
    <div class="row">
        <div class="col-12">
            <table class="table" v-if="section == 'hat'">
                <tbody>
                    <tr>
                        <th>Modem Buluştu mu?</th>
                        <td>{{ list.modem }}</td>
                    </tr>
                    <tr>
                        <th>Xdsl Hızı</th>
                        <td>{{ list.hiz }}</td>
                    </tr>
                    <tr>
                        <th>Download Kapasite Hız</th>
                        <td>{{ list.dkapasite }}</td>
                    </tr>
                    <tr>
                        <th>Upload Kapasite Hız</th>
                        <td>{{ list.ukapasite }}</td>
                    </tr>
                    <tr>
                        <th>Download Mevcut Hız</th>
                        <td>{{ list.dmevcuthiz }}</td>
                    </tr>
                    <tr>
                        <th>Upload Mevcut Hız</th>
                        <td>{{ list.umevcuthiz }}</td>
                    </tr>
                    <tr>
                        <th>Baglanilan Cl Id</th>
                        <td>{{ list.id }}</td>
                    </tr>
                    <tr>
                        <th>Veri Akışı Var mı?</th>
                        <td>{{ list.veri }}</td>
                    </tr>
                </tbody>
            </table> 
            <table class="table" v-else>
                <tbody>
                    <tr>
                        <th>Hız Profili</th>
                        <td></td>
                    </tr>
                    <tr>
                        <th>Bolge Müdürlüğü</th>
                        <td></td>
                    </tr>
                    <tr>
                        <th>Dslam Ip</th>
                        <td></td>
                    </tr>
                    <tr>
                        <th>Bağlanılan CLID</th>
                        <td></td>
                    </tr>
                    <tr>
                        <th>Mevcut Hızı</th>
                        <td></td>
                    </tr>
                    <tr>
                        <th>Kapasite Hızı</th>
                        <td></td>
                    </tr>
                    <tr>
                        <th>Attenuation</th>
                        <td></td>
                    </tr>
                    <tr>
                        <th>Noise Margin</th>
                        <td></td>
                    </tr>
                    <tr>
                        <th>Çıkış Gücü</th>
                        <td></td>
                    </tr>
                </tbody>
            </table>     
        </div>
    </div>
    <div class="d-flex justify-content-between mt-3">
        <b-button variant="light" @click="close()">Kapat</b-button>
    </div>
</b-modal>
</template>